export default __webpack_public_path__ + "static/media/step5.884b0de1.svg";